/**
 * Payment Documentation & Closing — /sframe-204-s5/:estateId
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-204-s5';

const ITEMS = [
  {
    id: 'doc-1',
    title: 'Collect All "Release of Claim" Forms',
    description:
      'Request written release/satisfaction letters from each creditor after payment.',
  },
  {
    id: 'doc-2',
    title: 'Compile Final Payment Ledger',
    description:
      'Create a complete record of every payment made: creditor, amount, date, confirmation number.',
  },
  {
    id: 'doc-3',
    title: 'Notify Heirs of Debt Settlement',
    description:
      'Inform beneficiaries that all estate debts have been paid and distribution can proceed.',
  },
];

export default function PayDebts_Documentation() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId) return <div className="p-8 text-stone-600 text-sm">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="Payment Documentation & Closing"
      backTo={`/sframe-204/${estateId}`}
      backLabel="← Pay Validated Debts"
      items={ITEMS}
      payDebtsHubKey="s5"
    />
  );
}
